import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9f2fcaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col relative" }
const _hoisted_2 = { class: "mt-40" }
const _hoisted_3 = { class: "flex flex-wrap md:flex-nowrap" }
const _hoisted_4 = { class: "w-full flex flex-row-reverse md:flex-row" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "o-text-h4 mb-20" }
const _hoisted_7 = { class: "md:w-full md:flex md:flex-row" }
const _hoisted_8 = { class: "flex-1 md:pr-30" }
const _hoisted_9 = { class: "font-bold inline-block w-110 mb-7 flex-shrink-0 mr-8 md:w-130 lg:w-170" }
const _hoisted_10 = { class: "hidden pr-40 lg:block lg:pr-60 xl:pr-80" }
const _hoisted_11 = { class: "font-normal mb-20 mt-20 md:mt-40" }
const _hoisted_12 = { class: "w-full sm:mb-30 sm:grid sm:gap-y-40 sm:gap-x-70 sm:grid-cols-2 md:pr-30 md:mb-0 lg:grid-cols-3" }
const _hoisted_13 = { class: "mb-10" }
const _hoisted_14 = { class: "whitespace-nowrap mb-5" }
const _hoisted_15 = { class: "price-line" }
const _hoisted_16 = { class: "price-line-amount" }
const _hoisted_17 = {
  key: 0,
  class: "o-text-caption m-0 text-dusty-grey text-right"
}
const _hoisted_18 = { class: "relative w-1/3 mt-10 pr-15 sm:pr-20 md:order-first md:pr-35 lg:w-1/4" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "mt-20 mb-40 w-full ml-auto md:w-1/3 md:mt-0 md:flex md:flex-col md:pt-38 xl:pt-46" }
const _hoisted_21 = { class: "md:ml-auto md:h-full md:flex md:flex-col md:justify-start" }
const _hoisted_22 = { class: "w-2/3 ml-auto align-to-grid md:ml-0" }
const _hoisted_23 = { class: "flex mt-20 w-auto flex-row-reverse md:flex-col justify-between md:mt-10" }
const _hoisted_24 = { class: "w-2/3 align-to-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegularItemImage = _resolveComponent("RegularItemImage")!
  const _component_PDPLink = _resolveComponent("PDPLink")!
  const _component_RegularItemQuantity = _resolveComponent("RegularItemQuantity")!
  const _component_RegularItemPrice = _resolveComponent("RegularItemPrice")!
  const _component_AddOfferItemToBasket = _resolveComponent("AddOfferItemToBasket")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.item.title), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moduleSpecs, (spec, index) => {
                  return (_openBlock(), _createElementBlock("dl", {
                    key: spec.name+index,
                    class: "flex w-full"
                  }, [
                    _createElementVNode("dt", _hoisted_9, _toDisplayString(spec.label), 1),
                    _createElementVNode("dd", null, _toDisplayString(spec.value), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$dictionary.format(_ctx.labels.lineItemQuantityShort, [1])), 1)
            ]),
            _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.labels.lineItemModulesHeading), 1),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (module) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: module.id,
                  class: "mb-30 sm:mb-0"
                }, [
                  _createVNode(_component_PDPLink, {
                    sku: module.variant.sku,
                    title: module.variant.name,
                    disabled: module.variant.isDiscontinued,
                    class: "block relative max-h-80 mx-auto mb-10 xl:max-w-100 xl:mb-20"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_RegularItemImage, {
                        variant: module.variant
                      }, null, 8, ["variant"])
                    ]),
                    _: 2
                  }, 1032, ["sku", "title", "disabled"]),
                  _createElementVNode("div", {
                    class: _normalizeClass({'opacity-35': module.variant.isDiscontinued})
                  }, [
                    _createElementVNode("h5", _hoisted_13, [
                      _createVNode(_component_PDPLink, {
                        sku: module.variant.sku,
                        title: module.variant.name,
                        disabled: module.variant.isDiscontinued,
                        class: _normalizeClass({'c-magic-line': !module.variant.isDiscontinued})
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(module.variant.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["sku", "title", "disabled", "class"])
                    ]),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getWidth(module.variant?.specifications)), 1),
                    _createVNode(_component_RegularItemQuantity, {
                      quantity: module.quantity,
                      class: "mb-5"
                    }, null, 8, ["quantity"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createTextVNode(_toDisplayString(_ctx.labels.lineItemPriceTotal) + " ", 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(module.price.salesPriceTotal?.amount), 1)
                    ]),
                    (module.price?.ecoTaxTotal)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$dictionary.get('b2c/productDetailItem/ecotaxincluded')), 1),
                          _createElementVNode("span", null, _toDisplayString(module.price.ecoTaxTotal?.amount), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("img", {
              src: _ctx.item.image,
              class: "w-full"
            }, null, 8, _hoisted_19)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_RegularItemQuantity, {
                quantity: 1,
                class: "mb-7 lg:hidden"
              }),
              (_ctx.item.price)
                ? (_openBlock(), _createBlock(_component_RegularItemPrice, {
                    key: 0,
                    price: _ctx.item.price,
                    quantity: _ctx.item.quantity,
                    class: "min-w-200 lg:min-w-250"
                  }, null, 8, ["price", "quantity"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                (_ctx.isPurchasable)
                  ? (_openBlock(), _createBlock(_component_AddOfferItemToBasket, {
                      key: 0,
                      "line-item-id": _ctx.item.id,
                      "button-text": _ctx.labels.lineItemAddToBasket,
                      class: "w-full md:w-300 lg:ml-auto"
                    }, null, 8, ["line-item-id", "button-text"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}